import {BarcodeCount, ScanBarcodesState} from '../types/scanBarcode';
import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {ScanBarcodesContext, initialState} from '../context/ScanBarcode';
import {useContext, useReducer} from 'react';

const reducer = {
  setBarcodesCount: function (
    state: ScanBarcodesState,
    action: PayloadAction<BarcodeCount>,
  ) {
    state.barcodeCount = action.payload;
  },
};

const slice = createSlice({
  initialState,
  name: 'ScanBarcode',
  reducers: reducer,
});

export function useScanBarcodeReducer() {
  const reducerInfo = useReducer(slice.reducer, initialState);
  return reducerInfo;
}

export function useScanBarcodeContext() {
  return useContext(ScanBarcodesContext);
}

export const ScanBarcodeAction = slice.actions;
